import { render, staticRenderFns } from "./DepartamentoPessoalContainer.vue?vue&type=template&id=1ffc53b9&scoped=true"
import script from "./DepartamentoPessoalContainer.vue?vue&type=script&lang=js"
export * from "./DepartamentoPessoalContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc53b9",
  null
  
)

export default component.exports